import { Injectable } from '@angular/core';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { BehaviorSubject, Observable } from 'rxjs';
import { IDateRange } from './statistics-top-menu-new.component';

@Injectable({
  providedIn: 'root'
})
export class StatisticsTopMenuNewService {
  private maxCompareDaysRangeAllowedSubject$ = new BehaviorSubject<{ maxDaysAllowed: number }>({ maxDaysAllowed: 0 });

  constructor() {}

  public setMaxCompareDaysRangeAllowed = (maxDaysAllowed: number) => {
    this.maxCompareDaysRangeAllowedSubject$.next({ maxDaysAllowed });
  };

  public maxCompareDaysRangeAllowed$ = (): Observable<{ maxDaysAllowed: number }> => {
    return this.maxCompareDaysRangeAllowedSubject$.asObservable();
  };

  public getButtonDateRange(selectedPeriodDates: IDateRange): string {
    const { dateFrom, dateTo } = selectedPeriodDates;

    let buttonDateRange = '';

    if (dateFrom.equals(dateTo)) {
      buttonDateRange = `${this.parseDateString(dateFrom).parsedDateString}`;
    }

    if (dateTo && !dateFrom.equals(dateTo)) {
      const from =
        dateFrom.month === dateTo.month ? this.parseDateString(dateFrom).day : `${this.parseDateString(dateFrom).day}.${this.parseDateString(dateFrom).month}`;

      buttonDateRange = `(${from}-${this.parseDateString(dateTo).parsedDateString})`;
    }

    return buttonDateRange;
  }

  private parseDateString = (date: NgbDate): { parsedDateString: string; day: string; month: string; year: string } => {
    const day = date.day.toString().padStart(2, '0');
    const month = date.month.toString().padStart(2, '0');
    const year = date.year.toString();

    return {
      parsedDateString: `${day}.${month}.${year}`,
      day,
      month,
      year
    };
  };
}
